import {Trash2} from "lucide-react";
import React, {useState} from "react";
import {Session} from "../../../../types";
import {DeleteConfirmationModal} from "./DeleteConfirmationModal";
import {useApiClient} from "../../../base/hooks/useApiClient";

interface Props {
    session: Session;
    onDelete: () => void;
}

export function DeleteSessionButton({ session, onDelete }: Props) {
    const apiClient = useApiClient();
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

    const handleDeleteClick = (session: Session) => {
        setIsDeleteModalOpen(true);
    };

    const handleDeleteConfirm = async () => {
        const response = await apiClient.delete(`sessions/${session.uuid}`);

        if (!response.ok) {
            console.error('Error deleting session');
            return;
        }

        onDelete();

        setIsDeleteModalOpen(false);
    };

    return (
        <>
            <button
                onClick={() => handleDeleteClick(session)}
                className="p-2 text-gray-400 hover:text-red-600 transition-colors"
            >
                <Trash2 className="h-5 w-5" />
            </button>
            <DeleteConfirmationModal
                isOpen={isDeleteModalOpen}
                onClose={() => setIsDeleteModalOpen(false)}
                onConfirm={handleDeleteConfirm}
                sessionName={session.name || ''}
            />
        </>
    );
}
